// index.js

import React from 'react';
import "./global.css";

import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom'; // ✅ Move BrowserRouter here
import App from './App';
import store from './store';
import { initTheme, ThemeProvider } from './theme';

initTheme();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ThemeProvider>
      <BrowserRouter> {/* ✅ Correct location */}
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </BrowserRouter>
    </ThemeProvider>
  </Provider>
);
